import useTranslation from 'next-translate/useTranslation'
import { useEffect } from 'react'

import Breadcrumbs from '@/atoms/Breadcrumb'
import useCreatorSurveys from '@/graphql/hooks/useCreatorSurveys'
import GTM from '@/services/GTM'

import Profile from './includes/Profile'
import SurveysSection from './includes/Profile/includes/Survey'
import Slider from './includes/Slider'
import { CreatorViewProps } from './ts'

function CreatorView({ creator, products }: CreatorViewProps) {
  const { nickname } = creator
  const { surveys } = useCreatorSurveys(creator.id)
  const { t } = useTranslation('global')

  // TODO: Refactor creator's products query

  const _products = [
    ...products.digital,
    ...products.fansi_class,
    ...products.fansi_collection,
    ...products.fansi_video,
    ...products.fansi_experience,
  ]

  useEffect(() => GTM.pushCreator(nickname, _products), [])

  return (
    <div>
      <Breadcrumbs
        crumbs={[
          { label: t('creators'), url: '/creators' },
          { label: `${nickname}` },
        ]}
        className="mb-8"
      />
      <div className="space-y-8 md:space-y-12 lg:space-y-16">
        <Profile creator={creator} />
        <SurveysSection surveys={surveys} />
        <Slider products={products?.fansi_experience} />
        <Slider products={products?.digital} />
        <Slider products={products?.fansi_collection} />
        <Slider products={products?.fansi_class} />
        <Slider products={products?.fansi_video} />
      </div>
    </div>
  )
}

export default CreatorView
